var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.456 7.181a3.685 3.685 0 0 1 7.089 0 .75.75 0 0 0 .721.546h.167a2.877 2.877 0 0 1 0 5.755h-1.209a.75.75 0 0 0 0 1.5h1.21a4.377 4.377 0 0 0 .372-8.74 5.184 5.184 0 0 0-9.612 0 4.378 4.378 0 0 0 .373 8.74h1.209a.75.75 0 0 0 0-1.5H5.567a2.877 2.877 0 0 1 0-5.755h.167a.75.75 0 0 0 .722-.546Zm4.074.475a.75.75 0 0 0-1.06 0l-2.822 2.821a.75.75 0 0 0 1.061 1.06l1.54-1.54v6.25a.75.75 0 0 0 1.5 0v-6.25l1.541 1.54a.75.75 0 0 0 1.061-1.06l-2.82-2.821Z",
    fill: "#666"
  })));
};
export default SvgUpload;